import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
    SettingOption,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import LCD from '@appblocks/codegeneration/Features/LCD';
import * as simulator from './simulator';
import * as tios from './tios';

export default class LCDImageWidgetNode extends BaseNode {
    constructor() {
        super();
        this.name = 'LCD Image Widget';
        this.icon = 'CgScreen';
        this.id = 'node_lcd_image_widget';
        this.linkedFeature = 'display_lib';
        this.requirements = ['tios'];

        this.inputs = [
            {
                name: 'Add Point',
                portId: 'lcd_image',
                params: [
                    // {
                    //     name: 'x_offset',
                    //     dataType: TibboDataType.INTEGER,
                    //     default: '0',
                    // },
                    // {
                    //     name: 'y_offset',
                    //     dataType: TibboDataType.INTEGER,
                    //     default: '0',
                    // },
                ],
            },
        ];

        const settings: Setting[] = [
            {
                id: 'WIDGET',
                name: 'Widget',
                settingType: SettingType.OPTION,
                required: true,
                refId: 'lcd_image_widget',
                default: '',
            },
            {
                id: 'IMG',
                name: 'Image',
                settingType: SettingType.OPTION,
                refId: 'lcd_image',
                required: false,
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getName(): string {
        const project: ProjectConfiguration = this.project;
        const widget = this.getSettingValue('WIDGET');
        if (!widget) return '';
        const widgetName = project.getFeature(widget)?.getSettingValue('NAME');
        const img = project.getFeature(this.getSettingValue('IMG'));
        if (!img) return `Clear {{$${widgetName}}}`;
        const imgName = img.getSettingValue('NAME');
        return `Set {{$${widgetName}}} image to ${imgName}`;
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const value = super.getSettingValue(settingId);
            if (value !== '') {
                return value;
            }
            return this.getName();
        }
        return super.getSettingValue(settingId);
    }

    getSettingOptions(settingId: string): SettingOption[] | undefined {
        return super.getSettingOptions(settingId);
    }

    getCodeBlocks(): CodeBlock[] {
        if (this.project.runtime === 'simulator') {
            return simulator.getCodeBlocks(this);
        }
        return tios.getCodeBlocks(this);
    }
}
